module.exports = __webpack_public_path__ + "img/member_default.2483d555.jpg";